var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

var _isSP;
var windowW = window.innerWidth;
var prewidth = window.innerWidth;

//preload
import {preload} from "../include/module";
preload();

//showMovie
// import {showMovie} from "../include/module";
// showMovie();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//parallaxHennnyano
import {parallaxHennnyano} from "../include/module";
parallaxHennnyano();

// pageTop
import {pageTop} from "../include/module";
pageTop();

// $(window).on('resize load' , function() {
//   if(windowW <= 1024){
//     _isSP = true;
//   } else {
//     _isSP = false;
//   };

//   //リサイズ処理 ブレイクポイントを跨いだらリロード
//   var nowWidth = window.innerWidth;
//   if(prewidth !== nowWidth){
//     if(prewidth < 1025) {
//       if(nowWidth >= 1025){
//         location.reload();
//       }
//     }else {
//       if(nowWidth < 1025){
//         location.reload();
//       }
//     }
//   };
// });



$(window).on('load' , function() {

  // scrollIndexAnime();
  $('.sw-Lower, .sw-Lower_Wrapper').addClass("show");
  setTimeout(function(){$('.sw-Ttl').addClass("show");},200);
  setTimeout(function(){$('#sw-Hennnyano').addClass("show");},700);

  showImg();
  toggleProduce();

});



  // ------------------------------------------------------------------------
// scrollIndexAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollIndexAnime = () => {

  const controller = new ScrollMagic.Controller();

  //ヘッダー縮める
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-Keyvisual',
    triggerHook: 0,
    offset: '100'
  })
  .setClassToggle('#st-Header,#st-Header_Logo', 'short')
  // .addIndicators({name: "1"})
  .addTo(controller);


};


// ------------------------------------------------------------------------
// showImg
// ----- BOTH
// ------------------------------------------------------------------------
const showImg = () => {
  const $modal = $('#gallery-Modal');
  const $img = $('#gallery-Modal_Img');
  const $content = $('#gallery-Modal_Content');
  var _currentNum;

  // open
  $('.js-Img').on('click', function(){

    const dataimg = $(this).attr('data-img');

    //img append
    $img.append('<img src="'+dataimg+'">');

    $modal.addClass('is-show');
    return false;
  });

  //close
  $(' #gallery-Modal_Close-1, #gallery-Modal_Close-0').on('click', function(){
    $modal.removeClass('is-show');
    setTimeout(function(){
      $img.children('img').remove();
    },200);
    return false;
  });

};


// ------------------------------------------------------------------------
// toggleProduce
// ----- BOTH
// ------------------------------------------------------------------------
const toggleProduce = () => {

  let contentsCount = $(".produce-List_Item").length;
  let n = 4;

  if(contentsCount <= n) {
    $("#produce-List_Btn").hide();
  } else {
    $(".produce-List_Item").slice(n).hide();
    $("#produce-List_Btn").click(function(){
      if ($(".produce-List_Item").slice(n).is(':hidden')) {
        $(".produce-List_Item").slice(n).slideDown(300);
        $(this).addClass("open");
      } else {
        $(".produce-List_Item").slice(n).slideUp(300);
        $(this).removeClass("open");
      }
    });
  }

};


// WEBPACK FOOTER //
// ./src/amashiro_v0/assets/js/works/script.js